import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from "sweetalert2";
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';
import { formatDuration } from '../../../../Common/DurationCommon';

function PrestationList(props) {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const navigate = useNavigate();

    const columns = [
        {
            name: "id",
            label: "Référence",
            options: { filter: true, sort: true }
        },
        {
            name: "label",
            label: "Libellé",
            options: { filter: true, sort: true }
        },
        {
            name: "prestationGroupLabel",
            label: "Groupe",
            options: { filter: true, sort: true }
        },
        {
            name: "type",
            label: "Type",
            options: { filter: true, sort: false }
        },
        {
            name: "description",
            label: "Description",
            options: { filter: false, sort: false }
        },
        {
            name: "duration",
            label: "Durée",
            options: { filter: true, sort: true }
        },
        {
            name: "planningDuration",
            label: "Temps en plus",
            options: { filter: true, sort: true }
        },
        {
            name: "price",
            label: "Prix (€)",
            options: { filter: true, sort: true }
        },
        {
            name: "createdAt",
            label: "Date de création",
            options: { filter: true, sort: true }
        },
        {
            name: "updatedAt",
            label: "Date de modification",
            options: { filter: true, sort: true }
        },
        {
            name: "action",
            label: "Action",
            options: { filter: false, sort: false }
        }
    ];

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Configuration',
            context: 'Liste des prestations',
            description: '',
            links: []
        });

        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, []);

    const getAction = (row) => {
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <Tooltip title={"Éditer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                navigate(getRoutePathname('configuration_prestation', { id: row.id }));
                            }}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Supprimer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                Swal.fire({
                                    title: "Êtes-vous sûr de vouloir supprimer cette prestation ?",
                                    text: "",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#87bba4",
                                    cancelButtonColor: "var(--greytext)",
                                    confirmButtonText: "Confirmer",
                                    cancelButtonText: "Annuler",
                                    reverseButtons: true,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        ApiHandler.delete(
                                            {
                                                route: "configuration_prestation_delete",
                                                params: { id: row.id },
                                            },
                                            (response) => {
                                                if (response.status === 200) {
                                                    dispatch(TableReload("configuration_prestation_list"));
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text: "Prestation supprimée avec succès",
                                                            variant: "success",
                                                        }),
                                                    );
                                                } else {
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text:
                                                                response.error && response.error.message
                                                                    ? response.error.message
                                                                    : "Une erreur inattendu s'est produite.",
                                                            variant: "error",
                                                        }),
                                                    );
                                                }
                                            },
                                        );
                                    }
                                });
                            }}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>
            </>
        );
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'configuration_prestation_list'}
                title={'Prestations'}
                columns={columns}
                mobileMode={'cards'}
                actionFirst={{
                    label: "Ajouter une prestation",
                    onClick: () => { navigate(getRoutePathname('configuration_prestation', { id: 'add' })); },
                }}
                promiseData={(resolve) => {
                    ApiHandler.get({ route: 'configuration_prestation_list' },
                        (response) => {
                            if (response.status === 200) {
                                let data = response.data;
                                for (let index in data) {
                                    data[index].action = getAction(data[index]);
                                    data[index].prestationGroupLabel = data[index].prestationGroupLabel || '-';
                                    data[index].type = data[index].isComplementOnly ? 'Complement uniquement' : 'Principale';
                                    data[index].description = data[index].description
                                        ? (data[index].description.length > 90 ? `${data[index].description.slice(0, 90)}...` : data[index].description)
                                        : '-';
                                    data[index].duration = formatDuration(data[index].duration);
                                    data[index].planningDuration = data[index].planningDuration !== null && data[index].planningDuration !== undefined
                                        ? formatDuration(data[index].planningDuration)
                                        : '-';
                                    data[index].createdAt = data[index].createdAt ? moment(data[index].createdAt).format('ll') : '-';
                                    data[index].updatedAt = data[index].updatedAt ? moment(data[index].updatedAt).format('ll') : '-';
                                    data[index].price = typeof data[index].price === 'number' ? data[index].price.toFixed(2) : data[index].price;
                                }
                                resolve(data);
                            } else {
                                resolve([]);
                            }
                        });
                }}
            />
        </ContentViewComponent>
    );
}

export default PrestationList;
